function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.053 4.98a1.953 1.953 0 013.818-.82l1.984 9.237c.011.053.06.088.114.082a.105.105 0 00.094-.105V1.955c0-1.08.873-1.955 1.95-1.955 1.078 0 1.952.875 1.952 1.955v11.45c0 .054.04.1.094.105a.103.103 0 00.113-.082l1.985-8.8A1.952 1.952 0 0122.38 3.59c.517.47.745 1.18.598 1.865L20.97 16.429a.108.108 0 00.065.117c.047.018.1 0 .128-.042l3.252-5.132a1.95 1.95 0 012.65-.593 1.96 1.96 0 01.679 2.637l-2.786 5.243a7.05 7.05 0 00-.827 3.32c0 4.4-1.229 8.019-5.852 8.021h-4.569a5.867 5.867 0 01-4.235-1.812L2.631 19.06v-.013a1.96 1.96 0 01-.116-2.765 1.95 1.95 0 012.76-.117l3.672 3.215a.105.105 0 00.173-.095L7.053 4.98z",
  fill: "currentColor"
})));